<template>
    <div class="address-list-item">
        <div class="address-name-item">
            <div class="address-name">{{address.addressName}}</div>
            <div class="address-default">
                <RadioBox
                    v-model="selectItem"
                    :value="selectItem"
                    :busEvent="busRadioBox"
                    @update:check="updateIsSelect()"
                ></RadioBox>
            </div>
        </div>
        <div class="address-item-full-name">
            {{address.firstname}} {{address.lastname}}
        </div>
        <div class="address-item-contact-number">{{ address.contactNumber }}</div>
        <div class="address-item-address">
            {{address.address}}
            {{address.subDistrictName}}
            {{address.districtName}}
            {{address.provinceName}}
            {{address.zipcode}}
        </div>
        <div class="address-item-footer" :class=" address.isDefault ? 'is-default' : 'no-default'">
            <div class="address-item-default" v-if="address.isDefault">
                <img src="../../assets/icon/icon-default.svg"/>
                <span class="ml-1">ที่อยู่หลัก</span>
            </div>
            <div class="address-manage">
                <div class="btn-delete" @click="onDeleteAddress()">
                    <img src="../../assets/icon/icon-bin.svg"/>
                    <span class="ml-1">ลบ</span>
                </div>
                <div class="btn-edit" @click="onEditAddress()">
                    <img src="../../assets/icon/icon-edit.svg"/>
                    <span class="ml-1">แก้ไข</span>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import Vue from 'vue';
import RadioBox from '../common/input/RadioBox.vue';
/**
 * @event onDeleteSuccess
 */
export default {
    name: "AddressListItem",
    props: {
        address: Object,
        busEvent: Object,
    },
    components: {
        RadioBox,
    },
    data: function() {
        return {
            selectItem: false,
            busRadioBox: new Vue(),
        }
    },
    created: function() {
        this.selectItem = this.address.isSelect;
    },
    mounted: function () {
        //page busEvent.
        this.busEvent.$on('onUpdate', this.onUpdate);
        //modal busEvent
    },
    methods: {
        onDeleteAddress: function() {
            this.$emit('onDeleteAddress', this.address);
        },
        onEditAddress: function() {
            this.$emit('onEditAddress', this.address);
        },
        updateIsSelect: function () {
            this.$emit('updateIsSelect', this.address);
        },
        onUpdate: function() {
            this.selectItem = this.address.isSelect
            this.busRadioBox.$emit('onChange', { value: this.selectItem });
        }
    },
}
</script>
<style lang="scss" scoped>
    .address-list-item {
        border: 1px solid #0e78c1;
        border-radius: 5px;
        padding: 12px;
        .address-name-item{
            display: flex;
            justify-content: space-between;
            .address-name {
                font-size: 24px;
                font-weight: 500;
                color: #4b4b4b;
                line-height: normal;
            }
        }
        .address-item-full-name{
            font-size: 20px;
            font-weight: 500;
            color: #4b4b4b;
            line-height: normal;
        }
        .address-item-contact-number {
            font-size: 20px;
            font-weight: 500;
            color: #0e78c1;
            line-height: normal;
        }
        .address-item-address {
            font-size: 20px;
            color: #4b4b4b;
            line-height: normal;
        }

        .address-item-footer {
            display: flex;
            width: 100%;
            padding-top: 12px;
            &.is-default {
                justify-content: space-between;
            }
            &.no-default {
                justify-content: end;
            }

            .address-item-default{
                border: #0e78c1;
                border-radius: 5px;
                background-color: #0e78c1;
                color: white;
                display: flex;
                gap: 2px;
                font-size: 20px;
                padding: 0 8px;
            }
            .address-manage {
                display: flex;
                // justify-content: end;
                align-items: center;
                gap: 12px;
                .btn-delete{
                    color: #ff0000;
                    font-size: 20px;
                }
                .btn-edit {
                    color: #0e78c1;
                    font-size: 20px;
                }
            }
        }
    }
</style>
